import { LOGIN_NAME } from 'widget/redux/client/actions/login-from-mobile-widget';


export default {
  [LOGIN_NAME]: 'widget.signIn.clicked',
};



// WEBPACK FOOTER //
// ./src/widget/analytics/bi/action-handlers/login.js